module.exports = __webpack_public_path__ + "static/img/3.65f80c5e.png";